import * as React from 'react'
import { SVGProps } from 'react'

function Leaderboard(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={props.width ?? 32}
      height={props.height ?? 32}
      fill={props.fill ?? 'none'}
      color={props.color ?? '#898989'}
      {...props}
    >
      <g
        stroke={props.color ?? '#898989'}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={1.5}
      >
        <path d="M3 19.5V9.75A.75.75 0 0 1 3.75 9h4.5M8.25 19.5V5.25A.75.75 0 0 1 9 4.5h6a.75.75 0 0 1 .75.75V19.5M21 19.5v-6a.75.75 0 0 0-.75-.75h-4.5" />
        <path d="M11.25 9.375 12.375 9v3.75M1.5 19.5h21" />
      </g>
      <defs>
        <clipPath id="a">
          <path fill="#fff" d="M0 0h24v24H0z" />
        </clipPath>
      </defs>
    </svg>
  )
}
export default Leaderboard
